import React, { useEffect } from 'react';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import MyAppBar from './MyAppBar';

import Home from './website/Home';
import RxEditor from '../containers/RxEditor';
import Faq from './website/Faq'
import { Switch, Route } from 'react-router-dom'

import queryString from 'query-string';
import ShoppingCart from '../components/ShoppingCart';

import { useDispatch } from "react-redux";
import { fetchProducts } from "../actions"

const theme = createMuiTheme({
	palette: {
		primary: {
			50: "#e3f2fd",
			100: "#bbdefb",
			200: "#90caf9",
			300: "#64b5f6",
			400: "#42a5f5",
			500: "#2196f3",
			600: "#1e88e5",
			700: "#1976d2",
			800: "#1565c0",
			900: "#0d47a1",
			A100: "#82b1ff",
			A200: "#448aff",
			A400: "#2979ff",
			A700: "#2962ff",
			contrastDefaultColor: "light"
		}
		/*secondary: {
		  ...green,
		  A400: '#00e677',
		},
		error: red,*/
	},
});


function App() {

	const parsed = queryString.parse(window.location.search);
	/*const dispatch = useDispatch();
	useEffect(() => {
		dispatch(fetchProducts());
	}, [dispatch])
	*/

	//Avoid Render backend sleeping
	useEffect(() => {
		// URL de ton backend Render
		const BACKEND_URL = "https://cartorion-backend.onrender.com/version/";

		// Fonction pour ping le backend
		const ping = async () => {
		try {
			await fetch(BACKEND_URL);
			console.log("Ping Render backend ✅");
		} catch (err) {
			console.error("Erreur lors du ping:", err);
		}
		};

		// Ping toutes les 13 minutes (avant l’endormissement à 15 min)
		const interval = setInterval(ping, 13 * 60 * 1000);

		// Ping une fois au démarrage
		ping();

		// Nettoyage
		return () => clearInterval(interval);
	}, []);
	
	return (
		<MuiThemeProvider theme={theme}>
			<div>
				{parsed.mode !== 'fs' && <MyAppBar />}
				<div>
					<Switch>
						<Route exact path='/' component={Home} />
						<Route path='/editor' component={RxEditor} />
						<Route path='/faq' component={Faq} />
						<Route path='/cart' component={ShoppingCart} />
					</Switch>


				</div>
			</div>
		</MuiThemeProvider>

	)
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js